<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
        <a [routerLink]="['/']" class="app-logo">
            <img width="21" height="25" class="app-logo-small" src="assets/layout/images/asmontech-logo.png" style="margin-top: 5px"/>
        </a>
        <button class="layout-sidebar-anchor p-link z-2 mb-2" type="button" (click)="anchor()"></button>
    </div>


    <div #menuContainer class="layout-menu-container">
        <app-menu></app-menu>
    </div>
</div>